import React from 'react';
import { compose, withProps } from 'recompose';

const contactInfo = {
  my: {
    tel: { id: "contact_us.withcontactinfodata_my_tel", default: "03 9212 8535" },
    whatsapp: { id: "contact_us.withcontactinfodata_my_whatsapp", default: "https://wa.me/60126485909?text=Hi" },
    info: { id: "contact_us.withcontactinfodata_my_info", default: "Monday – Friday: 9am - 6pm<br/>Saturdays: 9am - 1pm" }
  },
  th: {
    tel: { id: "contact_us.withcontactinfodata_th_tel", default: "+66 6000 35905<br/>(English support only)" },
    info: { id: "contact_us.withcontactinfodata_th_info", default: "Monday – Friday: 8am - 5pm<br/>Saturdays: 8am - 12pm" }
  },
  nz: {
    tel: { id: "contact_us.withcontactinfodata_nz_tel", default: "09 951 5884" },
    info: { id: "contact_us.withcontactinfodata_nz_info", default: "Monday – Friday: 11am - 7pm<br/>Closed on Public Holidays, Saturdays and Sundays" }
  },
  au: {
    tel: { id: "contact_us.withcontactinfodata_au_tel", default: "(03) 9998 0410 or (03) 9887 6338" },
    info: { id: "contact_us.withcontactinfodata_au_info", default: "Monday – Friday: 9am - 5pm<br/>Closed on Public Holidays, Saturdays and Sundays" },
    add: {id: "contact_us.withcontactinfodata_au_add", default: "Factory 20, 49 Corporate Boulevard Bayswater, VIC 3153 (not open to public)<p class='my-3'>ABN: 82 114 912 819</p>" }
  },
  ca: {
    tel: { id: "contact_us.withcontactinfodata_ca_tel", default: "(647) 559 2496" },
    info: { id: "contact_us.withcontactinfodata_ca_info", default: "Monday – Friday: 9am - 5pm<br/>Closed on Public Holidays, Saturdays and Sundays" },
    add: { id: "contact_us.withcontactinfodata_ca_add", default: "7181 Woodbine Avenue, Suite 114, Markham, Ontario, Canada L3R 1A3" }
  },
  us: {
    tel: { id: "contact_us.withcontactinfodata_us_tel", default: "(646) 918 5879" },
    whatsapp: { id: "contact_us.withcontactinfodata_us_whatsapp", default: "https://wa.me/60126485909?text=Hi" },
    info: { id: "contact_us.withcontactinfodata_us_info", default: "Monday - Friday: 9am to 5pm (Eastern Standard Time)" }
  },
  ph: {
    tel: { id: "contact_us.withcontactinfodata_ph_tel", default: "(02) 5488250" },
    info: { id: "contact_us.withcontactinfodata_ph_info", default: "Monday – Friday: 9am - 7pm<br/>Saturday - Sunday: 9am - 6pm<br/>Closed on Public Holidays" },
    add: { id: "contact_us.withcontactinfodata_ph_add", default: "16/F Unit 164 The Columbia Tower, Barangay Wack-wack, Ortigas Avenue, Mandaluyong City 1555" }
  },
  sg: {
    tel: { id: "contact_us.withcontactinfodata_sg_tel", default: "6871 8981" },
    info: { id: "contact_us.withcontactinfodata_sg_info", default: "Monday – Friday: 9am - 6pm<br/>Saturdays: 9am - 1pm" }
  },
  hk: {
    tel: { id: "contact_us.withcontactinfodata_hk_tel", default: "+852 5801 1888" },
    info: { id: "contact_us.withcontactinfodata_hk_info", default: "Monday – Friday: 9am - 6pm<br/>Saturdays: 9am - 1pm" }
  },
  gb: {
    tel: { id: "contact_us.withcontactinfodata_gb_tel", default: "+44 20 7048 7930" },
    info: { id: "contact_us.withcontactinfodata_gb_info", default: "Monday - Friday: 8am - 10am" }
  },
  id: {
    tel: { id: "contact_us.withcontactinfodata_id_tel", default: "021 3111 6176" },
    info: { id: "contact_us.withcontactinfodata_id_info", default: "Monday – Friday: 8am - 5pm<br/>Saturdays: 8am - 12pm" }
  },
};

export const withContactInfoData = compose(withProps({ contactInfo }));



// WEBPACK FOOTER //
// ./src/StaticPage/ContactUs/WithContactInfoData.js